// extracted by mini-css-extract-plugin
module.exports = {"profile":"index_page_profile__TwB2F"};